/**
 * Product Card Click Handler
 * Hace toda la tarjeta de producto clickeable
 */
(function () {
  if (window.productCardClickInitialized) return;
  window.productCardClickInitialized = true;

  document.addEventListener('click', function (e) {
    const card = e.target.closest('.card-wrapper.product-card-wrapper[data-product-url]');
    if (!card) return;

    // No navegar si el clic fue en un elemento interactivo
    const interactive = e.target.closest(
      'a, button, input, select, textarea, .quick-add, modal-opener, product-form, quick-add-bulk, quantity-popover'
    );
    if (interactive) return;

    const url = card.dataset.productUrl;
    if (url) {
      window.location.href = url;
    }
  });
})();
